import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
import {bool, func} from 'prop-types';
import React from 'react';

AppSidebarToggler.propTypes = {
    onClick: func.isRequired,
    isOpen: bool.isRequired,
};

export default function AppSidebarToggler({onClick, isOpen}:any) {
    if (isOpen) {
        return (
            <div className="root__toolbar">
                <IconButton
                    onClick={onClick}
                >
                    <ChevronLeftIcon />
                </IconButton>
            </div>
        );
    }
    
    return (
        <div className="root__toolbar">
            <IconButton
                onClick={onClick}
            >
                <MenuIcon />
            </IconButton>
        </div>
    );
}
